<template>
  <v-carousel class="reposition-navigator" hide-delimiter-background height="unset" :style="bannerPreHeight" cycle show-arrows show-arrows-on-hover>
    <v-carousel-item
      v-for="(banner, index) in banners"
      :key="index"
      :ripple="false"
      :href="banner.redirect.url"
      :to="banner.redirect"
      @click="selectBanner(banner)"
      :style="{
        cursor: banner.redirect.url ? 'pointer' : 'default'
      }"
    >
      <!-- 1761px because in large screens, the rest of the components wrapped in v-container reach a max width of 1761px (1785px - container paddings) -->
      <v-img :aspect-ratio="aspectRatio" :src="banner.image_desktop" :class="['mx-auto', rounded && 'rounded-1r']" eager />
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  props: {
    banners: { type: Array, required: true },
    rounded: { type: Boolean, default: false },
    preCalculateHeight: { type: Boolean, default: false },
    aspectRatio: { type: Number, default: 8 / 3 }
  },

  computed: {
    bannerPreHeight() {
      if (!this.preCalculateHeight) return
      const innerWidth = this.$vuetify.breakpoint.width - this.$vuetify.breakpoint.scrollBarWidth - 1
      const buttonHeight = 50
      return {
        minHeight: `${innerWidth / this.aspectRatio + buttonHeight}px`
      }
    }
  },
  methods: {
    selectBanner(banner) {
      if (banner.redirect.url) window.open(banner.redirect.url)
    }
  }
}
</script>

<style lang="scss" scoped>
.reposition-navigator {
  ::v-deep .v-carousel__controls {
    position: static;

    .v-carousel__controls__item {
      color: #a7a7a7;
      opacity: 1;
      width: 10px;
      height: 10px;

      .v-icon {
        font-size: 0.6rem !important;
      }

      &.v-btn--active {
        color: var(--v-light-green-base);
      }
    }
  }
}
</style>
